import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { NetworkStatus } from '@apollo/client';
import DocumentEmptyStateImage from 'images/DocumentEmptyState.png';
import useGetCompanyDocuments from '../templates/documents/useGetCompanyDocuments';
import useAddFromCompanyDocuments from './useAddFromCompanyDocuments';
import MultiSelectModal from 'components/templates/shared/MultiSelectModal';
import TemplateEmptyState from 'components/templates/shared/TemplateEmptyState';
import { translate } from 'javascripts/translations/i18n';

const CompanyDocumentsModal = ({ onRequestClose, projectId }) => {
  const navigate = useNavigate();

  const { loading, companyDocuments, fetchMore, networkStatus, hasNextPage } =
    useGetCompanyDocuments();

  const { addFromCompanyDocuments, loading: addLoading } =
    useAddFromCompanyDocuments({
      projectId,
      onSuccess: onRequestClose,
    });

  return (
    <MultiSelectModal
      isOpen
      onRequestClose={onRequestClose}
      footerContentBefore={{
        label: translate('documents.companyDocument.manageDocuments'),
        onClick: () => navigate('/templates/documents'),
      }}
      emptyState={
        <TemplateEmptyState
          message={translate('documents.companyDocument.emptyMsg')}
          imageSource={DocumentEmptyStateImage}
          action={
            !companyDocuments.length
              ? null
              : {
                  label: translate(
                    'documents.companyDocument.addDocumentButton',
                  ),
                  disabled: false,
                  onClick: () => {
                    navigate('/templates/documents');
                  },
                }
          }
        />
      }
      loading={
        (loading && networkStatus !== NetworkStatus.fetchMore) || addLoading
      }
      templates={companyDocuments}
      hasNextPage={hasNextPage}
      fetchMore={fetchMore}
      onAddTemplates={(documentBlueprintIds) => {
        addFromCompanyDocuments({ documentBlueprintIds });
      }}
      title={translate('documents.companyDocument.addsDocuments')}
      primaryActionLabel={translate('documents.companyDocument.addToProject')}
    />
  );
};

CompanyDocumentsModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
};

export default CompanyDocumentsModal;
